import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Popconfirm, Popover } from 'antd';
import React from 'react';

type TableActionsProps = {
  onEditClick: () => void;
  onDeleteConfirm: () => void;
  // Set when the API would refuse the delete: explains why instead of letting
  // the user find out from a 409.
  deleteDisabledReason?: string;
};

export const TableActions = ({
  onEditClick,
  onDeleteConfirm,
  deleteDisabledReason
}: TableActionsProps): JSX.Element => {
  const deleteIcon = (
    <DeleteOutlined
      className="inline-flex items-center justify-center rounded-md p-1 sm:p-0"
      style={{
        color: deleteDisabledReason ? '#BFBFBF' : '#FF6347',
        fontSize: 'inherit',
        cursor: deleteDisabledReason ? 'not-allowed' : 'pointer'
      }}
    />
  );

  return (
    <div
      className="flex justify-center items-center gap-4 text-xl sm:text-base"
      onClick={(e) => e.stopPropagation()}
      role="presentation"
    >
      <Popover content="Preview/Edit" trigger="hover">
        <EditOutlined
          className="inline-flex items-center justify-center rounded-md cursor-pointer p-1 sm:p-0 hover:bg-gray-100"
          style={{ color: '#438EF7', fontSize: 'inherit' }}
          onClick={onEditClick}
        />
      </Popover>

      {deleteDisabledReason ? (
        <Popover content={deleteDisabledReason} trigger="hover">
          {deleteIcon}
        </Popover>
      ) : (
        <Popconfirm
          title="Delete this permission?"
          okText="Delete"
          okType="danger"
          cancelText="Cancel"
          onConfirm={onDeleteConfirm}
        >
          <span className="hover:bg-gray-100 rounded-md">{deleteIcon}</span>
        </Popconfirm>
      )}
    </div>
  );
};
